import { createFileRoute } from '@tanstack/react-router'

import { LanguagesPage } from '~/boundedContext/settings/pages/languages'

export const Route = createFileRoute('/_main-layout/settings/languages')({
  component: LanguagesPage,
})
